module.exports = __webpack_public_path__ + "static/video_top-449a64d0f7d03c6f875b5e06b43d2f16.mp4";